import React from "react";

const HealthCheckPage = function () {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h2 className="mb-5">Health Check</h2>
          <p className="lead">This page is used for health check purposes</p>
        </div>
      </div>
    </div>
  );
};

export default HealthCheckPage;
